exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-all-text{cursor:pointer;color:#2789c0}.show-all-text:hover{text-decoration:underline}.give-me-a-pointer{cursor:pointer}html body div div#app.application.theme--light div.v-menu__content.theme--light.menuable__content__active.v-autocomplete__content div.v-select-list.v-card.theme--light div.v-list.theme--light div a.v-list__tile.v-list__tile--link.theme--light div.v-list__tile__action{display:none!important}", ""]);

// exports
